import { IQuote, IQuoteListResponse, IQoutePdfExport } from 'interfaces/IQuote';
import { useCallback, useMemo } from 'react';
import { useFetch } from './useFetch';

export const useQuoteService = () => {
  const { callApi } = useFetch();

  const GetQuotesByUser = useCallback(async () => {
    const Quote = await callApi<IQuoteListResponse[]>({
      url: 'Quote/GetQuotesByUser',
      method: 'get',
      prefixMsgError: 'error in useUserService - GetQuotesByUser:'
    });

    return Quote;
  }, [callApi]);

  const get = useCallback(
    async (id: string) => {
      const sc = await callApi<IQuote>({
        url: `Quote/Get/${id}`,
        method: 'get',
        prefixMsgError: 'error in useQuoteService - get:'
      });

      return sc;
    },
    [callApi]
  );

  const pdfexport = useCallback(
    async (id: string) => {
      const sc = await callApi<IQoutePdfExport>({
        url: `Quote/Export/${id}`,
        method: 'get',
        prefixMsgError: 'error in useQuoteService - pdfexport:'
      });

      return sc;
    },
    [callApi]
  );

  const add = useCallback(
    async (sc: IQuote) => {
      await callApi({
        url: 'Quote/Add',
        method: 'post',
        data: sc,
        prefixMsgError: 'error in useUserService - add:'
      });
    },
    [callApi]
  );

  const update = useCallback(
    async (sc: IQuote) => {
      await callApi({
        url: `Quote/Update`,
        method: 'put',
        data: sc,
        prefixMsgError: 'error in useQuoteService - update:'
      });
    },
    [callApi]
  );

  return useMemo(
    () => ({
      QuoteService: { get, GetQuotesByUser, add, update, pdfexport }
    }),
    [get, GetQuotesByUser, add, update, pdfexport]
  );
};
